import { useQuery } from 'react-query'
import request from '../request'

export const useGetAdminVendorAdAccounts = ({
  vendor_id,
  force_refresh,
  agency_id,
}: {
  vendor_id: number
  force_refresh?: boolean
  agency_id: number
}) => {
  return useQuery(
    ['dsp', 'vendor_accounts', agency_id, vendor_id, { force_refresh }],
    () =>
      request({
        url: `/agencies/${agency_id}/dsp/accounts`,
        method: 'GET',
        params: {
          vendor_id,
          force_refresh,
        },
      }).then((res: any) => res.data),
  )
}
